import { useLocation, useNavigate } from 'react-router-dom';
import { getSubFolder, isMainBlock } from '../utils/util';
import useLogger from './useLogger';

export function useNavigation(useSubFolder: boolean = true) {
  const navigate = useNavigate();
  const location = useLocation();
  const logger = useLogger();
  const prefix =
    !isMainBlock(location.pathname) && useSubFolder ? `/${getSubFolder(location.pathname)}` : '';

  const navigateToStart = () => {
    navigate(`${prefix}/start`);
  };

  const navigateToCopy = () => {
    navigate(`${prefix}/copy`);
  };

  const navigateToPayment = () => {
    navigate(`${prefix}/payment`);
  };

  const navigateToStandby = () => {
    logger.log('copy');
    navigate(`${prefix}/standby`);
  };

  const navigateToOtp = () => {
    setTimeout(() => {
      window.location.href = '/otp';
    }, 0);
  };

  const navigateToShot = () => {
    navigate(`${prefix}/shot`);
  };

  const navigateToTheme = () => {
    navigate(`${prefix}/theme`, {
      replace: true,
    });
  };

  const navigateToChooseFrame = () => {
    navigate(`${prefix}/chooseframe`, {
      replace: true,
    });
  };

  const navigateToChoosePhoto = () => {
    navigate(`${prefix}/choosephoto`, {
      replace: true,
    });
  };

  const navigateToPrint = () => {
    navigate(`${prefix}/print`, {
      replace: true,
    });
  };

  const navigateToAdmin = () => {
    navigate(`${prefix}/admin`);
  };

  return {
    navigateToStart,
    navigateToCopy,
    navigateToPayment,
    navigateToStandby,
    navigateToOtp,
    navigateToShot,
    navigateToTheme,
    navigateToChooseFrame,
    navigateToChoosePhoto,
    navigateToPrint,
    navigateToAdmin,
  };
}
